import { forwardRef } from "react";
import { SystemFieldType, SystemOperation, SystemPageType } from "../../../../Model/SystemModels";
import { CardField } from "../../../Common/Template/Card/CardField";
import { CardGroup } from "../../../Common/Template/Card/CardGroup";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";

export const AdminBookingCalendarCard = forwardRef<PageContainerBase, React.PropsWithChildren<{}>>((props, ref) => {
    return (
        <PageContainer pageType={SystemPageType.Card} title={"Booking calendar"} endpoint="/odata/booking/calendar" ref={ref} OnOpenPage={(record: any, operationType: SystemOperation) => {
            if (operationType === SystemOperation.Insert) {
                if (!record.distributorCode)
                    record.distributorCode = "";
                
                if (!record.partnerBusinessContractCode)
                    record.partnerBusinessContractCode = "";

                if (!record.languageCode)
                    record.languageCode = "";
            
                return record;
            }
        }}>
            <CardGroup name="localization" label="Localization" isOpen={true}>
                <CardField name="legalEntityCode" label="Legal entity" type={SystemFieldType.String} hasTableRelation tableRelationEndpoint="/odata/crm/legal/entity" tableRelationKey="code" tableRelationField="name"/>
                <CardField name="distributorCode" label="Distributore" type={SystemFieldType.String} hasTableRelation tableRelationEndpoint="/odata/distributor" tableRelationKey="code" tableRelationField="name"/>
                <CardField name="partnerBusinessContractCode" label="Partner business contract" type={SystemFieldType.String} hasTableRelation tableRelationEndpoint="/odata/partner/business/contract" tableRelationKey="code" tableRelationField="description"/>
                <CardField name="languageCode" label="Lingua" type={SystemFieldType.String} hasTableRelation tableRelationEndpoint="/odata/system/language" tableRelationKey="code" tableRelationField="name"/>
            </CardGroup>
            <CardGroup name="general" label="General" isOpen={true}>
                <CardField name="calendarId" type={SystemFieldType.String} label="Calendar Id" />
                <CardField name="syncActive" type={SystemFieldType.Boolean} label="Sync active" />
                <CardField name="lastSyncronizationDate" type={SystemFieldType.Date} label="Last syncronization date" />
                <CardField name="syncronizationDelayDays" type={SystemFieldType.Number} label="Syncronization delay days" />
                <CardField name="defaultForAppointments" type={SystemFieldType.Boolean} label="Default for appointments" />
                <CardField name="leadSyncronization" type={SystemFieldType.Boolean} label="Lead syncronization" />
            </CardGroup>
        </PageContainer>
    );
});